export default "__VITE_ASSET__DTgwe2Nm__"